import React from 'react';

const MissionSection = ({ quote, text }) => {
  return (
    <section className="mission">
      <h4 className='mission'>{quote}</h4>
      <p>{text}</p>
    </section>
  );
}

export default MissionSection;
